/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bald_Broad_Weasel_BaskInputs */

const en_bald_broad_weasel_bask = /** @type {(inputs: Bald_Broad_Weasel_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

const de_bald_broad_weasel_bask = /** @type {(inputs: Bald_Broad_Weasel_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

/**
* | output |
* | --- |
* | "Peer Feedback" |
*
* @param {Bald_Broad_Weasel_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bald_broad_weasel_bask = /** @type {((inputs?: Bald_Broad_Weasel_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bald_Broad_Weasel_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bald_broad_weasel_bask(inputs)
	return de_bald_broad_weasel_bask(inputs)
});